'use strict';

exports.__esModule = true;

var _MemoryRouter = require('react-router/MemoryRouter');

var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/MemoryRouter.js
// module id = 324
// module chunks = 168707334958949